import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
import FileHelpers from '../../../helpers/FileHelpers';
export default {
  html: _defineProperty({}, BlockTypes.FILE, function (_ref) {
    var node = _ref.node,
        attributes = _ref.attributes;
    var url = node.getIn(['data', 'url']);
    return React.createElement("p", null, React.createElement("a", Object.assign({}, attributes, {
      href: url
    }), node.getIn(['data', 'name'])));
  }),
  markdown: _defineProperty({}, BlockTypes.FILE, function (_ref2) {
    var node = _ref2.node,
        attributes = _ref2.attributes;
    var url = node.getIn(['data', 'url']).replace(' ', '+');
    var fileName = node.getIn(['data', 'name']) || url;

    var _ref3 = node.getIn(['data', 'meta']) || {},
        size = _ref3.size;

    return "[[".concat(fileName).concat(size ? " (".concat(FileHelpers.bytesToSize(size), ")") : "", "]](").concat(url, ")\n\n");
  })
};